import React, { Component } from "react";
import classes from "./Serial.module.scss";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../store/actions";

let content;

class Serial extends Component {
  constructor(props) {
    super(props);
    this.state = { SerialNumber: "", Message: "" };
    this.submitData = this.submitData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.resetData = this.resetData.bind(this);
  }

  handleChange(e) {
    this.setState({ SerialNumber: e.target.value });
  }

  submitData(e) {
    e.preventDefault();
    this.props.history.push(`/serial-number-search/${this.state.SerialNumber}`);
  }
  resetData(e) {
    e.preventDefault();
    this.setState({ SerialNumber: "", Message: "" });
    this.props.onFetchReset();
  }

  render() {
    content = (
      <div className={classes.SearchWrapper}>
        <div className={classes.SearchBar}>
          <h3>Serial Number Search</h3>
          <form onSubmit={this.submitData}>
            <input
              name="Search"
              id="Search"
              type="text"
              required="required"
              maxLength="30"
              value={this.state.SerialNumber}
              onChange={this.handleChange}
            />
            <button className={classes.Button}>Search</button>{" "}
            <button onClick={this.resetData} className={classes.Button}>
              Reset
            </button>
          </form>
        </div>
      </div>
    );
    return <>{content}</>;
  }
}

const mapStateToProps = (state) => {
  return {
    origin: { ...state.origin },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchSerial: (serial, token) =>
      dispatch(actions.fetchSerial(serial, token)),
    onFetchReset: () => dispatch(actions.fetchReset()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Serial));
